import groupBy from 'lodash/groupBy';

export function areasOfExcellenceState(
  state = {
    areasOfExcellenceById: {},
  },
  action
) {
  switch (action.type) {
    case 'RECEIVED_AREAS_OF_EXCELLENCE': {
      const { areasOfExcellence } = action.value;
      const areasOfExcellenceById = groupBy(areasOfExcellence, 'id');
      return { ...state, areasOfExcellence, areasOfExcellenceById };
    }
    default: {
      return state;
    }
  }
}
